import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore';

interface UpdateCustomerNamePayload {
  firstName: string;
  lastName: string;
  cardFirstName?: string;
  cardLastName?: string;
}

export const fetchEnrichedCustomerData = async () => {
  const { customerId } = useBoundStore.getState().customer;
  if (!customerId) {
    return;
  }
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  const path = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}`
    : `v3/secureonboarding/user/${customerId}`;
  const { data } = await HttpService.get(path);

  return data;
};

export const updateCustomerName = async (payload: UpdateCustomerNamePayload) => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();

  const path = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/name`
    : `v3/secureonboarding/user/${customerId}/name`;

  const { data } = await HttpService.post(path, {
    ...payload,
  });
  return data;
};
